exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay[data-v-0b295582]{width:100vw;height:100vh;top:0;background-color:rgba(0,0,0,.5);z-index:2;cursor:pointer}.detail[data-v-0b295582],.overlay[data-v-0b295582]{position:fixed;display:none;left:0;right:0;bottom:0}.detail[data-v-0b295582]{z-index:3;height:60vh;background:#fff}.showOverlay[data-v-0b295582]{display:block}", ""]);

// exports
